import { AfterSubmitFunc, FormTemplate } from 'ui-builder';
import { useProjectDocumentsService } from 'nekst-api';
import React from 'react';
import { DocumentLabelsDropdown } from './DocumentLabelsDropdown';

export function AddLabelsForm(props: {
  projectId: number,
  usedLabelsIds: number[],
  afterSubmitFunc?: AfterSubmitFunc,
  testID?: string,
}) {
  const service = useProjectDocumentsService();
  return (
    <FormTemplate<{ labelsIds: number[] }>
      title="Add Labels"
      testID={props.testID}
      submitFormFunc={async (data) => {
        await service.addLabels(props.projectId, data.labelsIds);

        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <DocumentLabelsDropdown
        source="labelsIds"
        label="Labels"
        excludeIds={props.usedLabelsIds}
      />
    </FormTemplate>
  );
}
